 import  types from "../actions/actionTypes";
import initialState from "./initialState";

const milestoneTemplateListUpdateRequiredReducer = (state = initialState.milestoneTemplateListUpdateRequired, action) => {
    switch (action.type) {
        case types.LOAD_MILESTONETEMPLATES_SUCCESS:
        case types.LOAD_MILESTONETEMPLATES_UPDATE_SUCCESS:
            return false;
        case types.UPDATED_MILESTONETEMPLATE_INCOMING:
           case types.UPDATED_MILESTONETEMPLATE_SUCCESS:
            return true;
        default:
            return state;
    }
}

export default milestoneTemplateListUpdateRequiredReducer;

